import { yupResolver } from '@hookform/resolvers/yup';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { FormControlLabel, Switch, FormControl, InputLabel, TextField, Button } from '@mui/material';
import { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import * as yup from 'yup';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import QrCodeIcon from '@mui/icons-material/QrCode';
interface SearchFormData {
  barcode: string;
}
function ContainerSearchBar() {
  const [barcode, setBarcode] = useState(false);
  const schema = yup.object().shape({
    barcode: yup.string().required('Código de barra o ubicación es requerido'),
  });
  const { control, formState } = useForm<SearchFormData>({
    mode: 'onChange',
    resolver: yupResolver(schema),
    defaultValues: {
      barcode: '',
    },
  });
  const { errors, isValid } = formState;

  return (
    <div className="flex mt-32">
      <div className="flex px-20">
        <FormControlLabel
          control={
            <Switch
              defaultChecked={barcode}
              onChange={() => setBarcode(!barcode)}
            />
          }
          label={barcode ? <QrCodeIcon /> : <LocationOnIcon />}
        />
        <div className="my-auto w-full">
          <Controller
            name="barcode"
            control={control}
            render={({ field }) => (
              <FormControl
                className="max-w-[320px]"
                variant="outlined"
                fullWidth
              >
                <InputLabel id="product-type-label">
                  {barcode
                    ? 'Ingrese el Código de barras'
                    : 'Ingrese la ubicación'}
                </InputLabel>
                <TextField variant="outlined" disabled fullWidth value={''} />
                {errors.barcode && (
                  <span className="text-red-500 text-sm mt-1">
                    {errors.barcode.message}
                  </span>
                )}
              </FormControl>
            )}
          />
        </div>
      </div>
      <Button
        variant="contained"
        color="secondary"
        className="my-auto mx-10"
        onClick={() => {}}
        disabled={!isValid}
      >
        <SearchOutlinedIcon />
        <span className="mx-8">Buscar</span>
      </Button>
    </div>
  );
}

export default ContainerSearchBar;